'use es6';

import { getType } from '../../common-message-format/operators/commonMessageFormatGetters';
export const isValidMessageHistoryType = (message, historyConfig) => Boolean(historyConfig[getType(message)]);